<template lang='pug'>
div(style='width: 100%')
  .columnWidth
    ConnectionConfigs(:canalFbChannels='canalFbChannels')
</template>
<script>
import ConnectionConfigs from '@/components/Settings/CanalMessenger/ConnectionConfigs'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import { mapFields } from 'vuex-map-fields'
export default {
  components: {
    ConnectionConfigs
  },
  props: {
    canalWebData: {
      type: Object,
      default: () => ({})
    },
    canalWebId: {
      type: String,
      default: () => ''
    },
    canalFbChannels: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    canalWebData: {
      deep: true,
      handler (nV) {
        this.modified = true
      }
    }
  },
  mixins: [isTenantMixin],
  computed: {
    ...mapFields('webChannel', ['modified'])
  },
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.columnWidth {
  float: left;
  width: 50%;
}
@media (max-width: 1239px) {
  .columnWidth {
    float: left;
    width: 100%;
  }
}
</style>
